
export const VIDEO_ACCEPT = {
  mp4: 'video/mp4',
  webm: 'video/webm',
  mov: 'video/quicktime',
  mkv: 'video/x-matroska',
  m4v: 'video/x-m4v',
  // ts: 'video/mp2t',
  // ogv: 'video/ogg',
  // mpg: 'video/mpeg',
  // mpeg: 'video/mpeg',
  // avi: 'video/x-msvideo',
  // wmv: 'video/x-ms-wmv',
  // flv: 'video/x-flv',
  // rm: 'application/vnd.rn-realmedia-vbr-rm', // 实际上是 application/vnd.rn-realmedia-vbr
  // rmvb: 'application/vnd.rn-realmedia-rmvb', // 实际上是 application/vnd.rn-realmedia
  // '3gp': 'video/3gpp',
};

export const AUDIO_ACCEPT = {
  mp3: 'audio/mpeg',
  mid: 'audio/midi',
  midi: 'audio/x-midi',
  wav: 'audio/x-wav',
  m3u: 'audio/x-mpegurl',
  m4a: 'audio/x-m4a',
  ogg: 'audio/ogg',
  // wma: 'audio/x-ms-wma',
  weba: 'audio/webm',
  aac: 'audio/aac',
  flac: 'audio/flac'
};

export const IMAGE_ACCEPT = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  png: 'image/png',
  bmp: 'image/bmp',
  webp: 'image/webp',
  svg: 'image/svg+xml',
};

export const getAccept = (keys: string[], type: 'video' | 'audio' | 'image' | 'all' = 'all') => {
  const res: string[] = [];
  if (type === 'video' || type === 'all') {
    res.push(
      ...keys.map((key) => VIDEO_ACCEPT[key] || '').filter(Boolean),
    );
  }
  if (type === 'audio' || type === 'all') {
    res.push(
      ...keys.map((key) => AUDIO_ACCEPT[key] || '').filter(Boolean),
    );
  }
  if (type === 'image' || type === 'all') {
    res.push(
      ...keys.map((key) => IMAGE_ACCEPT[key] || '').filter(Boolean),
    );
  }
  return res.join(',');
};

export const getAcceptByMediaType = (mediaType: 'video' | 'audio' | 'image' | 'all' = 'all') => {
  if (mediaType === 'image') {
    const keys = Object.keys(IMAGE_ACCEPT);
    return getAccept(keys, 'image'); 
  }
  if (mediaType === 'video') {
    const keys = Object.keys(VIDEO_ACCEPT);
    return getAccept(keys, 'video'); 
  }
}